const initialState = {
    studentCoins: 0,
    student: {},
    dinosaur: { cluster: "ICT", level: 0 },
    gated: {loading:true, gated: false},
    updateAvatar: false,
    flipConsented: false
};

const studentReducer = (state = initialState, action) => {
    switch (action.type) {

        case 'SET_STUDENT_COINS':
            return { ...state, studentCoins: action.studentCoins };
        case 'SET_STUDENT_DETAILS':
            return { ...state, student: action.student };
        case 'SET_UPDATE_AVATAR':
            return { ...state, updateAvatar: action.updateAvatar };
        case 'SET_DINOSAUR':
            return { ...state, dinosaur: action.dinosaur };
        case 'SET_GATED':
            return {...state, gated: action.gated};
        case 'SET_STUDENT_CONSENT':
            return {...state, flipConsented: action.studentConsent}
        default:
            return state;
    }
}

export { studentReducer as default }